export default __webpack_public_path__ + "static/media/botAvatar.d8f88bdb.png";